import { render } from "./AllIndexesDetail.vue?vue&type=template&id=68a25135"
import script from "./AllIndexesDetail.vue?vue&type=script&lang=js"
export * from "./AllIndexesDetail.vue?vue&type=script&lang=js"

import "./AllIndexesDetail.vue?vue&type=style&index=0&id=68a25135&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__